import { supabaseClient } from "@/lib/supabase";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export const deleteTemplate = async (templateId: string) => {
	const { error } = await supabaseClient
		.from("templates")
		.delete()
		.eq("template_id", templateId);

	if (error) throw error;
	return templateId;
};

export const useDeleteTemplate = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: deleteTemplate,
		onSuccess: () => {
			toast.success("Template deleted successfully");
			queryClient.invalidateQueries({ queryKey: ["templates"] });
		},
		onError: (error) => {
			toast.error("Failed to delete template");
			console.error("Template delete error:", error);
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: ["templates"] });
		},
	});
};
